import React from "react";
// import BradcrumeSection from "../Others/BradcrumeSection";
import { Link } from "react-router-dom";
import "./FreeLegalAdviceCSS.css";
import "./PaginationCss.css";
import LegalBradcrumeSection from "./LegalBradcrumeSection";
// import TalktoLawyerForm from "./TalktoLawyerForm";
import LegalProfileBox from "./LegalProfileBox";
import { AllServicesCategory } from "../FetchAPI";
import ComunityServiceBox from "./ComunityServiceBox";
import { useAuth } from "../../Store/AuthContext";
// import { AllCommunityService } from "../FetchAPI";

export default function FreeLegalAdvice() {
  const { RendomTokenfetch } = useAuth();
  const [AllserviceCat] = AllServicesCategory(RendomTokenfetch);
  // const [AllserviceCat] = AllCommunityService(RendomTokenfetch, "2");
  // console.log(AllserviceCat);
  //
  return (
    <>
      <LegalBradcrumeSection
        Pagename={"Free Advice From Top Rated Experts"}
        page1={[{ name: "free-advice" }]}
      />

      <section
        className={`legal_section section_padding_top section_padding_bottom `}
        style={{ background: " #f5f7fc82" }}
      >
        <div className="auto-container">
          <div className="row wow fadeInUp">
            <div className="col-lg-8 col-md-12 Askformrow">
              <div className="searchAskqusBOX mb-4">
                <form className="mt-2">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control communitySearchinput"
                      placeholder="Search Answers"
                    />
                    <Link className="input-group-text communitySearchinput">
                      <i className="fa fa-search"></i>
                    </Link>
                  </div>
                </form>

                <div className="askBTN mt-2">
                  <Link
                    to="/ask-a-free-question"
                    className="askfreequestBTN sencondBTNhover"
                  >
                    Ask a free question
                  </Link>
                  <Link className="talkLawyerBTN sencondBTNhover">
                    Talk to a Lawyer
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row wow fadeInUp">
            <div className="col-lg-8 col-md-12 Askformrow">
              {AllserviceCat &&
                AllserviceCat.map((catValue, index) => (
                  <div className="formdesedataBOX" key={index}>
                    <h4 className="formdescheading">{catValue.category} </h4>
                    <div className="formdesctitlebox">
                      <div className="formDatarow">
                        <ul className="formdataUL row p-0 m-0">
                          {
                            <ComunityServiceBox
                              RendomTokenfetch={RendomTokenfetch}
                              CatID={catValue.id}
                            />
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}

              {/* <div className="formdesedataBOX">
                <h4 className="formdescheading">Talk to a Lawyer</h4>
                <p className="formdescPera">
                  Just fill in your details to immediately get the best matched
                  lawyers for legal issues. Every lawyer profile has been
                  verified, and you can contact them within minutes.
                </p>
                <div className="formdesctitlebox">
                  <div className="formDatarow">
                    <TalktoLawyerForm />
                  </div>
                </div>
              </div> */}
            </div>

            <div className="col-lg-4">
              <LegalProfileBox />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
